<template>
    <div class="page_container project_management_wrap">
        <div class="project_management_top">
            <div class="search_left">
                <el-input size="small" v-model="searchForm.keyword" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                </el-input>
                <el-date-picker  v-model="searchForm.date" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange"      range-separator=" " @change="handleClickSearch"  start-placeholder="请选择创建日期" end-placeholder=""> </el-date-picker>
                <el-select clearable  placeholder="请选择项目状态" size="small" v-model="searchForm.status" @change="handleClickSearch" >
                    <el-option label="进行中" value="0" ></el-option>
                    <el-option label="已完结" value="1" ></el-option>
                    <el-option label="已关闭" value="2" ></el-option>
                </el-select>
            </div>

            <div class="handle_right">
                <ul class="project_list_type_list">
                    <el-tooltip content="切换为列表模式" effect="dark" placement="top">
                        <li :class="{'active':listMode==='table'}" class="project_list_type_item"  @click="handleClickProjectListType('table')">
                            <i class="iconfont icon-kanban"></i>
                            <span>列表</span>
                        </li>
                    </el-tooltip>
                    <el-tooltip content="切换为看板模式" effect="dark" placement="top">
                        <li :class="{'active':listMode==='board'}" class="project_list_type_item"  @click="handleClickProjectListType('board')">
                            <i class="iconfont icon-liebiao"></i>
                            <span>看板</span>
                        </li>
                    </el-tooltip>
                </ul>
                <el-button type="primary" size="small" @click="handleClickAddProject">新建项目</el-button>
            </div>

        </div>
        <div class="project_management_bottom">
            <template v-if="listMode==='table'">
                <CustomVxeTable
                        :loading="loading"
                        ref="customTable"
                        class="custom-table"
                        id="projectManagementTable"
                        :tableData="tableData"
                        :reduceHeight="reduceHeight"
                        :isShowToolBar="true"
                        :empty-render="{ name: 'NotData' }"
                        :pagination.sync="pagination"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                        :customConfig="tableCustomConfig">
                    <vxe-column fixed="left" field="project_manage_name" title="项目名称"  width="120" show-overflow>
                        <template #default="{ row }">
                            <span class="link-label" @click="handleClickDetail(row)" v-text="row.project_manage_name"></span>
                        </template>
                    </vxe-column>
                    <vxe-column field="status" title="项目状态" min-width="120px"  show-overflow>
                        <template #default="{ row }">
                            <span class="status_code status_code0"  v-if="row.status == 0 ">进行中</span>
                            <span class="status_code status_code1"  v-if="row.status == 1 ">已完结</span>
                            <span class="status_code status_code2"  v-if="row.status == 2 ">已关闭</span>
                        </template>
                    </vxe-column>
                    <vxe-column field="head_user" title="项目负责人"  width="108" show-overflow>
                        <template #default="{ row }">
                            <userDetailPopover v-if="row.head_user" :uid="row.head_user.id">
                                <div slot="container">
                                    <div class="user_head">
                                        <img :src="row.head_user.avatar ? row.head_user.avatar : defaultImg" alt="" />
                                        <span v-text="row.head_user.name"></span>
                                    </div>
                                </div>
                            </userDetailPopover>
                        </template>
                    </vxe-column>
                    <vxe-column field="addr" title="项目地址"  width="120" show-overflow></vxe-column>
                    <vxe-column field="project" title="关联商机"  width="180" >
                        <template #default="{ row }">
                            <el-popover  placement="bottom"  width="360" trigger="click" v-if="row.project && row.project.length>0">
                                <div slot="reference" class="flexLeftAutoRight ellipsis link-label"  >
                                    <p  class="leftText ellipsis">
                                        <span   v-text="row.project[0].relate_detail.name"></span>
                                    </p>
                                    <span v-if="row.project.length > 1"  class="rightText" v-text="'+'+ row.project.length"></span>
                                </div>
                                <div class="project_relate_business_table_wrap">
                                    <div class="project_relate_business_table_title">
                                        关联商机（{{row.project.length}}）
                                    </div>
                                    <div class="project_relate_business_table_list">
                                        <ul>
                                            <li v-for="item in row.project">
                                                <div v-if="item.relate_detail" class="business_name link-label"  @click="handleClickRelateHandle('business_detail',{project_id:item.relate_id})">{{item.relate_detail.name}}</div>
                                                <div v-if="item.relate_detail" class="business_stage"  >
                                                    <span v-if="!item.relate_detail.project_stage" v-text="item.relate_detail.project_stage == -1 ? '赢单' :item.relate_detail.project_stage == - 2 ? '输单': item.relate_detail.project_stage == -3 ? '无效商机' :''"></span>
                                                    <span v-else>
                                                        <span v-if="item.relate_detail.stage_detail">{{item.relate_detail.stage_detail.name}}</span>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-popover>
                        </template>
                    </vxe-column>
                    <vxe-column field="order" title="关联订单"  width="180" show-overflow>
                        <template #default="{ row }">
                            <el-popover  placement="bottom"  width="360" trigger="click">
                                <div slot="reference" class="flexLeftAutoRight ellipsis link-label"  v-if="row.order && row.order.length>0">
                                    <p  class="leftText ellipsis">
                                        <span   v-text="row.order[0].relate_num"></span>
                                    </p>
                                    <span v-if="row.order.length>1" class="rightText" v-text="'+'+ row.order.length"></span>
                                </div>
                                <div class="project_relate_order_table_wrap">
                                   <div class="project_relate_order_table_title">
                                       关联订单（{{row.order.length}}）
                                   </div>
                                    <div class="project_relate_order_table_list">
                                        <ul>
                                            <li v-for="item in row.order">
                                                <div class="project_relate_order_table_top" v-if="item.relate_detail">
                                                    <div @click="handleClickRelateHandle('order_detail',{order_id:item.relate_id,order_num:item.relate_detail.order_num})" class="order_num link-label"><i class="iconfont icon-a-dingdan1"></i>{{item.relate_detail.order_num}}</div>
                                                    <div class="order_time">{{item.relate_detail.created_at}}</div>
                                                </div>
                                                <div class="project_relate_order_table_bottom" v-if="item.relate_detail">
                                                    <div class="order_head_user">
                                                        <span class="order_head_user_text">发起人：</span>
                                                        <div class="user_head" v-if="item.relate_detail.user">
                                                            <img :src="item.relate_detail.user.avatar ? item.relate_detail.user.avatar : defaultImg" alt="" />
                                                            <span v-text="item.relate_detail.user.name"></span>
                                                        </div>
                                                    </div>
                                                    <div class="order_price">
                                                        订单金额：<span v-text="'¥'+ item.relate_detail.total_price">¥</span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-popover>
                        </template>
                    </vxe-column>
                    <vxe-column field="work_order" title="关联工单"  width="180" show-overflow>
                        <template #default="{ row }">
                            <el-popover  placement="bottom"  width="360" trigger="click">
                                <div slot="reference" class="flexLeftAutoRight ellipsis link-label"  v-if="row.work_order && row.work_order.length>0">
                                    <p  class="leftText ellipsis">
                                        <span   v-text="row.work_order[0].relate_num"></span>
                                    </p>
                                    <span v-if="row.work_order.length>1"  class="rightText" v-text="'+'+ row.work_order.length"></span>
                                </div>
                                <div class="project_relate_work_order_table_wrap">
                                    <div class="project_relate_work_order_table_title">
                                        关联工单（{{row.work_order.length}}）
                                    </div>
                                    <div class="project_relate_work_order_table_list">
                                        <ul>
                                            <li v-for="item in row.work_order">
                                                <div class="project_relate_work_order_table_top">
                                                    <div class="work_order_num link-label" >
                                                        <span @click="handleClickRelateHandle('work_order_detail',{id:item.relate_id,work_order_num:item.relate_num})"><i class="iconfont icon-a-dingdan1"></i>{{item.relate_num}}</span>
                                                        <span class="work_order_status" :class="'work_order_status' + item.relate_detail.status" v-if="item.relate_detail">{{item.relate_detail.status_text}}</span>
                                                    </div>
                                                    <div class="work_order_time" v-if="item.relate_detail">{{item.relate_detail.created_at}}</div>
                                                </div>
                                                <div class="project_relate_work_order_table_bottom" v-if="item.relate_detail && item.relate_detail.workorder_type_id">
                                                    {{item.relate_detail.workorder_type_id.name}}
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-popover>
                        </template>
                    </vxe-column>
                    <vxe-column field="stocks" title="出入库记录"  width="180" show-overflow>
                        <template #default="{ row }">
                            <el-popover  placement="bottom"  width="380" trigger="click">
                                <div slot="reference" class="flexLeftAutoRight ellipsis link-label"  v-if="row.stocks && row.stocks.length>0">
                                    <p  class="leftText ellipsis">
                                        <span   v-text="row.stocks[0].log_num"></span>
                                    </p>
                                    <span v-if="row.stocks.length>1" class="rightText" v-text="'+'+ row.stocks.length"></span>
                                </div>
                                <div class="project_relate_warehouse_table_wrap">
                                    <div class="project_relate_work_order_table_title">
                                        出入库记录（{{row.stocks.length}}）
                                    </div>
                                    <div class="project_relate_warehouse_table_list">
                                        <ul>
                                            <li v-for="item in row.stocks">
                                                <div class="project_relate_warehouse_table_top">
                                                    <div class="warehouse_num ">
                                                        {{item.stock_type_text}}：<span class="link-label" @click="handleClickRelateHandle(item.type + '_record_detail',item)">{{item.log_num}}</span>
                                                    </div>
                                                    <div class="warehouse_time">{{item.created_at}}</div>
                                                </div>
                                                <div class="project_relate_warehouse_table_bottom">
                                                    <div class="warehouse_num">
                                                        业务编号：<span class="link-label" @click="handleClickRelateHandle(item.relate_handle_type,item)">{{item.relate_num}}</span>
                                                    </div>
                                                    <div class="warehouse_head_user">
                                                        <span class="warehouse_head_user_text">处理人：</span>
                                                        <userDetailPopover v-if="item.user" :uid="item.user.id">
                                                            <div slot="container">
                                                                <div class="user_head">
                                                                    <img :src="item.user.avatar ? item.user.avatar : defaultImg" alt="" />
                                                                    <span v-text="item.user.name"></span>
                                                                </div>
                                                            </div>
                                                        </userDetailPopover>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-popover>
                        </template>
                    </vxe-column>
                    <vxe-column field="total_price"  align="right" title="项目订单总金额"  width="130" show-overflow></vxe-column>
                    <vxe-column field="repay_price" align="right" title="实际回款总金额"  width="130" show-overflow></vxe-column>
                    <vxe-column field="no_repay_price" align="right" title="待回款总金额"  width="120" show-overflow></vxe-column>
                    <vxe-column field="note" title="项目概况"  width="120" show-overflow></vxe-column>
                    <vxe-column field="operate" width="100" fixed="right">
                        <template #header>
                            <span>操作</span>
                            <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                            </el-tooltip>
                        </template>
                        <template #default="{ row }">
                            <div class="table-operate-icon">
                                <el-dropdown placement="bottom-end" trigger="click">
                                    <el-tooltip content="更多" effect="dark" placement="top">
                                        <i class="iconfont el-icon-more"></i>
                                    </el-tooltip>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item  @click.native="handleClickEditProject(row)">编辑</el-dropdown-item>
                                        <el-dropdown-item  @click.native="handleClickChangePerson(row)">更换负责人</el-dropdown-item>
                                        <el-dropdown-item v-if="row.status == 0" @click.native="handleClickEnd(row)">完结</el-dropdown-item>
                                        <el-dropdown-item v-if="row.status == 1" @click.native="handleClickCancelEnd(row)">取消完结</el-dropdown-item>
                                        <el-dropdown-item v-if="row.status == 0" @click.native="handleClickClose(row)">关闭</el-dropdown-item>
                                        <el-dropdown-item v-if="row.status == 2" @click.native="handleClickCancelClose(row)">取消关闭</el-dropdown-item>
                                        <el-dropdown-item v-if="row.status == 2" @click.native="handleClickDelete(row)">删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </vxe-column>
                    <template #empty>
                        <div class="custom-table-empty">
                            <div class="custom-table-empty-img"></div>
                            <p class="custom-table-empty-txt">暂无数据</p>
                            <div>
                                <el-button type="primary" plain size="small" @click="handleClickAddProject">新建项目</el-button>
                            </div>
                        </div>
                    </template>
                </CustomVxeTable>
            </template>
            <template v-if="listMode==='board'">
                <div class="project_management_board" v-loading="loading">
                    <ul  v-infinite-scroll="onLoadList">

                        <li v-for="(item,key) in tableData" :key="key" @click="handleClickDetail(item)">
                            <div class="project_management_board_top">
                                <div class="title ellipsis" v-text="item.project_manage_name"></div>
                                <div class="status_wrap">
                                    <span class="status_text status0" v-if="item.status == 0 ">进行中</span>
                                    <span class="status_text status1" v-if="item.status == 1 ">已完结</span>
                                    <span class="status_text status2" v-if="item.status == 2" >已关闭</span>

                                </div>
                            </div>
                            <div class="project_management_board_bottom">
                                <div class="project_management_board_bottom_left">

                                    <div class="progress_wrap">
                                        <SemiCircularProgress :percentage="item.repay_price_ratio" :strokeWidth="14" :inactiveColor="'#2990FF'" :activeColor="'#5AB333'" :width="140" :height="70" />
                                        <SemiCircularProgress class="progress2" :percentage="item.cost_price_ratio" :strokeWidth="12" :inactiveColor="'#ffffff'" :activeColor="'#F0AA32'" :width="116" :height="56" :progressText="'已回款'+item.repay_price_ratio+'%'" />
                                    </div>
                                    <div class="price_wrap">
                                        <div class="price_item price_code1">项目订单总金额：{{item.total_price}}</div>
                                        <div class="price_item price_code2">实际回款总金额：{{item.repay_price}}</div>
                                        <div class="price_item price_code3">项目成本：{{item.total_cost}}</div>
                                    </div>

                                </div>
                                <div class="project_management_board_bottom_right">
                                    <div class="field_name">项目成员</div>
                                    <div class="field_value">
                                        <i class="iconfont icon-renyuan"></i> <span v-text="item.members.map(map => map.member_user ? map.member_user.name :'').join(',')"></span>
                                    </div>
                                    <div class="field_name mt_4">项目最新动态：</div>
                                    <div class="field_value ellipsis4">
                                        <div v-for="log in item.logs">
                                            <div v-if="log.log_detail">
                                                <div v-if="log.log_detail.type == 'custom' && log.log_detail.created_at && log.log_detail.updated_at">
                                                    <div v-html="log.log_detail.user.name + '：' + log.log_detail.content.text + updatedDate(log.log_detail.created_at,log.log_detail.updated_at)"></div>
                                                </div>
                                                <div v-else>
                                                    <span v-text="getLogDescriptions(log.log_detail).title"></span>
                                                    <span @click="handleClickRelateHandle(getLogDescriptions(log.log_detail).handle_type,getLogDescriptions(log.log_detail).info)" class="link-label" v-text="getLogDescriptions(log.log_detail).relate_num"></span>
                                                    <span v-text="getLogDescriptions(log.log_detail).content_text"></span>
                                                    <span class="link-label" v-if="getLogDescriptions(log.log_detail).derivative_num" v-text="getLogDescriptions(log.log_detail).derivative_num" @click="handleClickRelateHandle(getLogDescriptions(log.log_detail).derivative_handle_type,getLogDescriptions(log.log_detail).derivative)"></span>
                                                </div>
                                            </div>



                                        </div>
                                    </div>

                                </div>
                            </div>
                        </li>

                    </ul>
                </div>
            </template>

        </div>

        <ProjectTpl :projectAddVisible.sync="projectAddVisible" v-if="projectAddVisible" :projectId="projectId"   @success="handleClickSearch"/>
        <RelatedHandle ref="relatedHandle" @relatedHandleSuccess="relatedHandleSuccess"/>
        <ChangeThePerson v-if="changeThePersonDialogVisible" :projectId="projectId"  @success="handleClickSearch" :dialogVisible.sync="changeThePersonDialogVisible"/>
    </div>
</template>
<script>
import {ProjectManageList,ProjectManageDel,ProjectManageFinish, ProjectManageFinishCancel, ProjectManageClose,  ProjectManageCloseCancel} from "@/api";
import {pagination} from '@/mixins'
import CustomVxeTable from "@/components/pComponents/vxe-table";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import SemiCircularProgress from '@/components/pComponents/SemiCircularProgress.vue';
import ProjectTpl from "./component/project_tpl.vue";
import RelatedHandle from "./component/related_handle.vue";
import ChangeThePerson from "./component/change_the_person";
export default {
    name: "ProjectManagement",
    mixins: [pagination],
    components: {
        CustomVxeTable,
        userDetailPopover,
        SemiCircularProgress,
        ProjectTpl,
        RelatedHandle,
        ChangeThePerson
    },
    data() {
        return {
            loading:false,
            defaultImg: require('@/assets/images/default.jpg'),
            tableData:[],
            searchForm:{
                keyword: '',
                date:[],
                status:''
            },
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "project_manage_name";
                },
                checkMethod: (col) => {
                    return col.column.field !== "project_manage_name";
                },
                allowSort: true,
            },
            listMode:'table',
            progress:10,
            projectAddVisible:false,
            projectId:0,
            changeThePersonDialogVisible:false,
            beforeRoute:false, // 是否是从上一页返回
        }
    },
    created() {
        if(!this.beforeRoute){this.getTableData();}
    },
    // 从上一页返回的时候刷新
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.beforeRoute = true
            if(from.name == 'ProjectDetail'){
                vm.handleClickSearch();
            }
        });
    },
    computed: {
        reduceHeight() {
            return this.tableData.length ? 160 : 170
        }
    },
    mounted() {

    },
    methods: {
        handleClickProjectListType(mode){
            this.listMode = mode
            this.handleClickSearch()
        },
        // 筛选
        handleClickSearch(){
            this.pagination.pageNum = 1;
            this.tableData = []
            this.getTableData();
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.customTable.handleOpenCustomShow();
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        // 加载更多
        onLoadList() {
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.pagination.pageNum++;
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            ProjectManageList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                date: this.searchForm.date,
                keyword: this.searchForm.keyword,
                status: this.searchForm.status,

            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    data.forEach(item => {
                        this.$set(item, 'project',  item.relates.filter(item=>item.relate_type==='project').length ? item.relates.filter(item=>item.relate_type==='project') : [])
                        this.$set(item, 'order',  item.relates.filter(item=>item.relate_type==='order').length ? item.relates.filter(item=>item.relate_type==='order') : [])
                        this.$set(item, 'work_order',  item.relates.filter(item=>item.relate_type==='workorder').length ? item.relates.filter(item=>item.relate_type==='workorder') : [])


                        if(item.order && item.order.length > 0){
                            this.$set(item,'total_price',item.order.reduce((acc, order) => acc + Number(order.relate_detail.total_price), 0).toFixed(2))
                            this.$set(item,'no_repay_price',item.order.reduce((acc, order) => acc + Number(order.relate_detail.no_repay_price), 0).toFixed(2))
                            this.$set(item,'repay_price',item.order.reduce((acc, order) => acc + Number(order.relate_detail.repay_price), 0).toFixed(2))
                            let repay_price_ratio = Number(item.repay_price) / Number(item.total_price)
                            let cost_price_ratio = Number(item.total_cost) / Number(item.total_price)
                            this.$set(item,'repay_price_ratio',(isNaN(repay_price_ratio ) || repay_price_ratio < 0) ? 0: (repay_price_ratio  * 100).toFixed(2)) //回款比例
                            this.$set(item,'cost_price_ratio',(isNaN(cost_price_ratio)  || cost_price_ratio < 0 )? 0  : (cost_price_ratio  * 100).toFixed(2)) //成本比例
                        }else{
                            this.$set(item,'total_price',0.00)
                            this.$set(item,'no_repay_price',0.00)
                            this.$set(item,'repay_price',0.00)
                            this.$set(item,'repay_price_ratio',0.00) //回款比例
                            this.$set(item,'cost_price_ratio',0.00) //成本比例
                        }

                        if(item.stocks && item.stocks.length){
                            item.stocks.forEach((list)=>{
                                this.$set(list,'relate_handle_type',list.biz_type == 'order' ? 'order_detail' : '')
                                if(list.biz_type == 'order'){
                                    this.$set(list,'order_id',list.biz_type_id)
                                    this.$set(list,'order_num',list.relate_num)
                                }
                            })
                        }

                    })
                    if(this.listMode == 'board'){
                        this.tableData = this.tableData.concat(data)
                    }else{
                        this.tableData = data
                    }
                    this.pagination.total = total
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },

        // 功能操作
        handleClickRelateHandle(type,data){
            this.$refs.relatedHandle.projectId = data.id
            this.$refs.relatedHandle.handleClickRelateHandle(type,data)
        },
        // 功能操作完毕后回调
        relatedHandleSuccess(data){
            console.log(data);

        },
        // 新建项目
        handleClickAddProject(){
            this.projectId = 0
            this.projectAddVisible = true
        },
        // 编辑
        handleClickEditProject(row){
            this.projectId = row.id
            this.projectAddVisible = true
        },
        // 详情
        handleClickDetail(row){
            this.$router.push({
                name: 'ProjectDetail',
                query: {
                    id: row.id,
                    name:row.project_manage_name
                },
                params: {
                    isPush: true,
                },
            })
        },
        // 更换负责人
        handleClickChangePerson(row){
            this.projectId = row.id
            this.changeThePersonDialogVisible = true
        },
        // 完结
        handleClickEnd(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '完结提示',
                message: h('div', null, [
                    h('span', null, '项目完结后，将不再同步数据，在选择项目时，该项目将隐藏，无法关联'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageFinish({id:row.id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '完结成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getTableData()
                    }
                })
            }).catch(() => {

            })
        },
        // 取消完结
        handleClickCancelEnd(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消完结',
                message: h('div', null, [
                    h('span', null, '确定要取消完结吗？已关联的数据将同步更新'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageFinishCancel({id:row.id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '取消完结成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getTableData()
                    }
                })
            }).catch(() => {

            })
        },
        // 关闭
        handleClickClose(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '关闭提示',
                message: h('div', null, [
                    h('span', null, '关闭项目后未处理完的事项将不再同步，在选择项目时，该项目将隐藏，无法关联'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageClose({id:row.id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '关闭成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getTableData()
                    }
                })
            }).catch(() => {

            })
        },
        // 取消关闭
        handleClickCancelClose(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消关闭',
                message: h('div', null, [
                    h('span', null, '确定要取消关闭吗？已关联的数据将同步更新'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageCloseCancel({id:row.id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '取消关闭成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getTableData()
                    }
                })
            }).catch(() => {

            })
        },
        // 删除
        handleClickDelete(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '删除提示',
                message: h('div', null, [
                    h('span', null, '确定要删除该项目吗？删除后，项目数据将会清空'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageDel({id:row.id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getTableData()
                    }
                })
            }).catch(() => {

            })
        },

        updatedDate(dateTime,logTime){
            let time = logTime.split(' ')[0]
            let date = dateTime.split(' ')[0]
            if(date != time){
                return `（${time}）`
            }else{
                return ''
            }
        },
        // 日志映射
        getLogDescriptions(log){
            let data = null
            switch (log.type) {
                case "project_add":
                    data = {
                        title:'新建商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break;  //新增商机
                case "project_relate":
                    data = {
                        title:'关联商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //关联商机
                case "project_push":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`已推进至“${log.content?.project_stage_name}”阶段`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //商机推进
                case "project_add_quotation":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`新增报价`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name},
                        derivative_num:log.content?.project_quotation_num,  //衍生编号
                        derivative_handle_type:'view_the_quotation', //衍生操作type
                        derivative:{  //衍生信息
                            project_quotation_id:log.content?.project_quotation_id,
                            title:log.content?.project_quotation_num,
                        }
                    }
                    break; //商机新增报价

                case "order_add":
                    data = {
                        title:'新建订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //新增订单
                case "order_relate":
                    data = {
                        title:'关联订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //关联订单
                case "order_edit":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//订单编辑
                case "order_stock_edit_out":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑-出库`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单编辑


                case "order_rent_to_sale":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-租借转销售`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//售后-租借转销售
                case "order_purchase":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新增代采，代采编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.purchase_num,  //衍生编号
                        derivative_handle_type:'order_purchase_detail', //衍生操作type
                        derivative:{  //衍生信息
                            purchase_num:log.content?.purchase_num,
                            id:log.content?.purchase_id,
                        }
                    }
                    break;//订单代采
                case "order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建开票${log.content?.invoice_price}，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                    break;//订单发起开票
                case "order_repay":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建回款${log.content?.repay_price}，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                    break; //订单发起回款
                case "order_return":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-归还`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;//订单归还
                case "order_stock_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单出库
                case "order_stock_returned_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`售后退货已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单退货入库
                case "order_stock_return_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单归还已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单归还入库
                case "order_stock_replace_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break; //订单损坏换新入库
                case "order_stock_replace_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break; //订单损坏换新出库
                case "order_return_goods":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退货`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        // derivative_num:log.content?.out_num,  //衍生编号
                        // derivative_handle_type:'out_record_detail', //衍生操作type
                        // derivative:{  //衍生信息
                        //     out_num:log.content?.out_num,
                        //     id:log.content?.out_id,
                        // }
                    }
                    break;//订单退货

                case "order_renew":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-续租`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break; //订单续租
                case "order_replace":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-损坏换新`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;  //订单损坏换新
                case "order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退款`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;  //订单退款
                case "stock_out":
                    data = {
                        title:`普通出库：出库编号`,
                        handle_type:'out_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通出库
                case "stock_in":
                    data = {
                        title:`普通人库：入库编号`,
                        handle_type:'in_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通入库

                case "finance_bad_debt":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`坏账金额${log.content?.bad_price}`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:'详情',  //衍生编号
                        derivative_handle_type:'finance_bad_debt_detail', //衍生操作type
                        derivative:{  //衍生信息
                            related_num:log.relate_num,
                        }
                    }
                    break;//订单坏账
                case "finance_repay_confirm":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.repay_price}已确认，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                    break; //财务回款确认
                case "finance_repay_void":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.void_price}已作废，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.void_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.void_num,
                        }
                    }
                    break; //回款作废
                case "finance_order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`开票${log.content?.invoice_price}已确认，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                    break; //财务确认开票
                case "finance_order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`退款${log.content?.refund_price}已确认，应付编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.payable_no,  //衍生编号
                        derivative_handle_type:'payable_detail', //衍生操作type
                        derivative:{  //衍生信息
                            id:log.content?.payable_no,
                        }

                    }
                    break;  //财务确认订单退款
                    //'finance_purchase_refund':'采购退款待定',
                    //'finance_purchase_payment':'采购付款待定',

                case "workorder_add":
                    data = {
                        title:'新建工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //新建工单
                case "workorder_relate":
                    data = {
                        title:'关联工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //关联工单

                case "workorder_feedback_start":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已开始实施`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单开始
                case "workorder_depart":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已出发`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单实施人出发
                case "workorder_feedback_end":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已实施完成`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单实施人结束
                case "workorder_close":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已关闭`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单关闭
                case "workorder_finish":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已结单`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单结单
                case "workorder_evaluate":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已评价`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单评价


                case "approval_relate":
                    data = {
                        title:`${log.user?.name}关联${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                    break; //关联审批
                case "approval_add":
                    data = {
                        title:`${log.user?.name}发起${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                    break; //新建审批

                default:
                    data = {
                        title:`${log.user?.name}`,
                        handle_type:'',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{relate_id:log.relate_id}
                    }
                    break;
            }
            return data
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/styles/project_management.scss";
</style>
<style lang="scss">
.project_relate_business_table_wrap{
    width: 100%;
    .project_relate_business_table_title{
        width: 100%;
        line-height: 22px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
    }
    .project_relate_business_table_list{
        width: 100%;
        max-height: 280px;
        overflow: auto;
        ul{
            width: 100%;
            li{
                padding: 12px 0;
                border-bottom: 1px solid rgba(232, 232, 232, 1);
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                .business_name{
                    width: calc(100% - 100px);
                    line-height: 22px;
                }
                .business_stage{
                    width: 96px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    text-align: right;
                }
            }
        }
    }
}
.project_relate_order_table_wrap{
    width: 100%;
    .project_relate_order_table_title{
        width: 100%;
        line-height: 22px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
    }
    .project_relate_order_table_list{
        width: 100%;
        max-height: 280px;
        overflow: auto;
        ul{
            width: 100%;
            li{
                padding: 12px 0;
                border-bottom: 1px solid rgba(232, 232, 232, 1);
                box-sizing: border-box;
                .project_relate_order_table_top{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    line-height: 22px;
                    margin-bottom: 4px;
                    .order_num{
                        font-size: 14px;
                        i{
                            margin-right: 4px;
                        }
                    }
                    .order_time{
                        font-size: 12px;
                        color: rgba(102, 102, 102, 1);
                    }
                }
                .project_relate_order_table_bottom{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .order_head_user{
                        display: flex;
                        align-items: center;
                        flex: 1;
                        .order_head_user_text{
                            flex: 1;
                            min-width: 58px;
                        }
                    }
                    .order_price{
                        font-size: 12px;
                        color: rgba(153, 153, 153, 1);
                        span{
                            color:rgba(51, 51, 51, 1)
                        }
                    }
                }

            }
        }
    }
}
.project_relate_work_order_table_wrap{
    width: 100%;
    .project_relate_work_order_table_title{
        width: 100%;
        line-height: 22px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
    }
    .project_relate_work_order_table_list{
        width: 100%;
        max-height: 280px;
        ul{
            width: 100%;
            li{
                padding: 12px 0;
                border-bottom: 1px solid rgba(232, 232, 232, 1);
                box-sizing: border-box;
                .project_relate_work_order_table_top{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    line-height: 22px;
                    margin-bottom: 4px;
                    .work_order_num{
                        font-size: 14px;
                        i{
                            margin-right: 4px;
                        }
                        span.work_order_status{
                            margin-left: 4px;
                            padding: 0 8px;
                            line-height: 22px;
                            display: inline-block;
                            border-radius: 4px;
                            font-size: 12px;
                            &.work_order_status0, &.work_order_status1,&.work_order_status2,&.work_order_status3,&.work_order_status4{
                               background-color: rgba(240, 170, 50, .3);
                                color: rgba(240, 170, 50, 1)
                            }
                            &.work_order_status-1 {
                               background-color: rgba(228, 65, 68, .3);
                                color: rgba(228, 65, 68, 1);
                            }
                            &.work_order_status-2, &.work_order_status-3, &.work_order_status7 {
                               background-color: rgba(191, 191, 191, .3);
                                color: rgba(191, 191, 191, 1);
                            }
                            &.work_order_status5, &.work_order_status6 {
                               background-color: rgba(90, 179, 51, .3);
                                color: rgba(90, 179, 51, 1);
                            }
                        }

                    }
                    .work_order_time{
                        font-size: 12px;
                        color: rgba(102, 102, 102, 1);
                    }
                }
                .project_relate_work_order_table_bottom{
                    width: 100%;
                    line-height: 18px;
                    font-size: 12px;
                    color: rgba(51, 51, 51, 1);

                }

            }
        }
    }
}
.project_relate_warehouse_table_wrap{
    width: 100%;
    .project_relate_warehouse_table_title{
        width: 100%;
        line-height: 22px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
    }
    .project_relate_warehouse_table_list{
        width: 100%;
        max-height: 280px;
        overflow: auto;
        ul{
            width: 100%;
            li{
                padding: 12px 0;
                border-bottom: 1px solid rgba(232, 232, 232, 1);
                box-sizing: border-box;
                .project_relate_warehouse_table_top{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    line-height: 22px;
                    margin-bottom: 4px;
                    .warehouse_num{
                        font-size: 14px;
                        color: rgba(153, 153, 153, 1);
                    }
                    .warehouse_time{
                        font-size: 12px;
                        color: rgba(102, 102, 102, 1);
                    }
                }
                .project_relate_warehouse_table_bottom{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .warehouse_num{
                        flex: 1;
                        font-size: 14px;
                        color: rgba(153, 153, 153, 1);
                    }
                    .warehouse_head_user{
                        display: flex;
                        align-items: center;
                        .warehouse_head_user_text{
                            flex: 1;
                            min-width: 58px;
                        }
                    }

                }

            }
        }
    }
}
</style>

